import axios from "axios"
import {Customer, CustomerInfo} from "./Customer"
import {getAxiosConfigWithAuth} from "../../utils/auth"

export default class CustomerService {
	public async getCustomers(
		firstName: string,
		lastName: string,
		emailAddress: string,
		orderNumber: string,
		phoneNumber: string
	): Promise<Array<Customer>> {
		firstName = encodeURIComponent(firstName)
		lastName = encodeURIComponent(lastName)
		emailAddress = encodeURIComponent(emailAddress)
		orderNumber = encodeURIComponent(orderNumber)
		phoneNumber = encodeURIComponent(phoneNumber)
		const response = await axios
			.get(
				`${process.env.REACT_APP_CARE_CUSTOMER_SERVICE}/v1/customers?firstName=${firstName}&lastName=${lastName}&emailAddress=${emailAddress}&exampleOrder=${orderNumber}&examplePhoneNumber=${phoneNumber}`,
				getAxiosConfigWithAuth()
			)
			.then((response) => {
				return response.data as Array<Customer>
			})
		return response
	}

	public async getCustomer(id: string): Promise<CustomerInfo> {
		const res = await axios
			.get(
				`${process.env.REACT_APP_CARE_CUSTOMER_SERVICE}/v1/customers/${id}`,
				getAxiosConfigWithAuth()
			)
			.then((res) => {
				return res.data as CustomerInfo
			})
		return res
	}
}
